module.exports = __webpack_public_path__ + "img/img_chaxun.3316501c.jpg";